import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const RouteWaypointCard = ({routeway}) => {
    return (
        <div className="row card-waypoint">
            <div className="col card-waypoint-icon">
                <FontAwesomeIcon icon={routeway.waypoint_icon} className="text-secondary" />
                <div className="row text-center">
                    <span className="h2 text-secondary">{routeway.order}</span>
                </div>
            </div>
            <div className="col card-waypoint-info">
                <div className="small text-muted">{routeway.waypoint_name}</div>
                <div>{routeway.full_address}</div>
            </div>
        </div>
    );
};
export default RouteWaypointCard;
